import React from 'react';
import './common/sensitiveFields.scss';
import ForecastReport from './ForecastReport/index.jsx';

const JklcForecastClone = () => (
  <div className="jklc-forecast-clone">
    <ForecastReport />
  </div>
);

export default JklcForecastClone;
